export default {
  NAMESPACE: 'Wix_Ads',
  MAIN_TEXT_KEY: 'Wix_Ads_2_top_banner_hover_1',
  MAIN_TEXT_DEFAULT: 'Upgrade your website to remove Wix ads',
  BUTTON_TEXT_KEY: 'Wix_Ads_2_top_banner_hover_CTA',
  BUTTON_TEXT_DEFAULT: 'Start Now',
  wixLogoPlaceHolder: '{Wix}',
  HREF_KEY_DEFAULT: `//premium.wix.com/wix/api/premiumStart?referralAdditionalInfo=edhtml_PREVIEW_FREE_SITE_BANNER_CLICK`,
  HREF_KEY_NEW: 'Wix_Ads_2_top_banner_hover_href_new',
  HREF_KEY_OLD: 'Wix_Ads_2_top_banner_hover_href_old',
};
